module.exports = __webpack_public_path__ + "img/icon-pencil.8e37fcfe.svg";